module.exports = __webpack_public_path__ + "static/media/covi_phy_ven.e16478ab.png";